class VacanciesFilter {
    init() {
        this.select = document.querySelector(".vacancies-filter__select");
        this.items = document.querySelectorAll(".vacancy-card");

        if (!this.select) return;

        this.select.addEventListener("change", this.handleFilterChange.bind(this));
    }

    handleFilterChange(event) {
        const selected = event.target.value;
        this.filterItems(selected);
    }

    filterItems(location) {
        this.items.forEach(item => {
            if (location === "all") {
                item.style.display = "";
            } else {
                const matches = item.classList.contains(`filter-${location}`);
                item.style.display = matches ? "" : "none";
            }
        });
    }
}

export default VacanciesFilter;